<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.queryValue" class="input-with-select" size="small">
						<el-select v-model="params.queryKey" slot="prepend" placeholder="请选择">
							<el-option label="演出ID" :value="1"></el-option>
							<el-option label="演出名称" :value="2"></el-option>
							<el-option label="结款单ID" :value="3"></el-option>
							<el-option label="结款方ID" :value="4"></el-option>
							<el-option label="结款方名称" :value="5"></el-option>
							<el-option label="合同编号" :value="6"></el-option>
							<el-option label="账户名" :value="7"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.isBalance" placeholder="请选择" size="small">
						<el-option label="不限制结款单状态" :value="-1"></el-option>
						<el-option label="仅看待结款的" :value="0"></el-option>
						<el-option label="仅看已结款的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.sellIdentity" placeholder="请选择" size="small">
						<el-option label="不限制售票模式" :value="0"></el-option>
						<el-option label="仅看独家的" :value="1"></el-option>
						<el-option label="仅看多平台的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.balanceType" placeholder="请选择" size="small">
						<el-option label="不限制结算方式" :value="0"></el-option>
						<el-option label="仅看预付款的" :value="1"></el-option>
						<el-option label="仅看后付款的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.isNormalBalance" placeholder="请选择" size="small">
						<el-option label="不限制是否正常结款" :value="-1"></el-option>
						<el-option label="仅看正常结款的" :value="1"></el-option>
						<el-option label="仅看暂停结款的" :value="0"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.settlementType" placeholder="请选择" size="small">
						<el-option label="不限制结算单类型" :value="0"></el-option>
						<el-option label="仅看按演出的" :value="1"></el-option>
						<el-option label="仅看按场次的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.specialSettlement" multiple collapse-tags placeholder="请选择异常结款场景"
						size="small" style="width:100%">
						<el-option label="涉及结款分账的" :value="1"></el-option>
						<el-option label="有过二次退款的" :value="2"></el-option>
						<el-option label="涉及线下分销结款的" :value="3"></el-option>
						<el-option label="第三方服务费秀动承担的" :value="4"></el-option>
						<el-option label="有额外费用需要票款抵扣的" :value="5"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-cascader clearable v-model="params.showTypeTagId" :options="showTypeTagList"
						:props="{value:'id',label:'name',children:'tags', emitPath:false}" placeholder="不限制活动类型"
						size="small" style="width:100%"></el-cascader>
				</el-col>

				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.activityChannel" placeholder="不限制演出来源" class="fl fl-big-select" clearable
						size="small">
						<el-option label="不限制演出来源" value=""></el-option>
						<el-option v-for="(item, index) in activityChannel" :label="item.value" :key="index"
							:value="item.key"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.siteTypeTagId" placeholder="请选择" size="small">
						<el-option label="不限制场地类型" value=""></el-option>
						<el-option v-for="(item, index) in siteTypeTagList" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-col>

				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.status" placeholder="请选择" size="small">
						<el-option label="不限制演出状态" :value="-1"></el-option>
						<el-option label="仅看预售中的" :value="2"></el-option>
						<el-option label="仅看已结束的" :value="3"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
					<div class="clearfix timeType">
						<el-input class="input-with-select fl" size="small">
							<el-select v-model="params.queryTimeKey" slot="prepend" placeholder="请选择">
								<el-option label="演出结束时间" :value="1"></el-option>
								<el-option label="结款申请时间" :value="2"></el-option>
								<el-option label="实际打款时间" :value="3"></el-option>
							</el-select>
						</el-input>
						<el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始时间"
							end-placeholder="结束时间" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']" unlink-panels>
						</el-date-picker>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="page-btns-box">
			<el-button v-if="$utils.have('/activityFinanceSettle/exportInfo')" type="primary" icon="el-icon-download"
				size="small" @click="download1" :loading="downLoading1">导出费用明细</el-button>
			<el-button v-if="$utils.have('/activityFinanceSettle/exportReceivables')" type="primary"
				icon="el-icon-download" size="small" @click="download2" :loading="downLoading2">导出结款信息</el-button>

			<el-button v-if="$utils.have('/activityFinanceSettle/batchReceivables')" type="primary"
				icon="el-icon-tickets" size="small" @click="$refs.batch.show()">批量结款</el-button>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>

				<el-table-column prop="id" label="结款单ID"></el-table-column>
				<el-table-column prop="statusView" label="结款单状态" min-width="100"></el-table-column>
				<el-table-column prop="settlementTypeView" label="结款单类型" min-width="100"></el-table-column>
				<el-table-column prop="settlementSessionNum" label="结款场次数" min-width="100"></el-table-column>
				<el-table-column prop="activityId" label="演出ID"></el-table-column>
				<el-table-column prop="activityName" label="演出名称" min-width="250"
					show-overflow-tooltip></el-table-column>
				<el-table-column prop="activityStatusView" label="演出状态"></el-table-column>
				<el-table-column prop="showTypeView" label="活动类型"></el-table-column>
				<el-table-column prop="applyUser" label="结款方" min-width="130" show-overflow-tooltip></el-table-column>
				<el-table-column prop="sellIdentityView" label="售票模式"></el-table-column>
				<el-table-column prop="balanceTypeView" label="结算方式"></el-table-column>
				<el-table-column prop="incomeTotalAmount" label="收入合计"></el-table-column>
				<el-table-column prop="deductionTotalAmount" label="扣款合计"></el-table-column>
				<el-table-column prop="expectedTotalAmount" label="预计结款"></el-table-column>
				<el-table-column prop="settlementAmount" label="实际结款金额" min-width="100"></el-table-column>
				<el-table-column prop="createTimeView" label="申请时间" min-width="150"
					show-overflow-tooltip></el-table-column>
				<el-table-column prop="playTimeView" label="实际打款时间" min-width="150"
					show-overflow-tooltip></el-table-column>
				<el-table-column prop="contractSn" label="合同编号" min-width="130"></el-table-column>
				<el-table-column prop="principalUser" label="项目负责人" min-width="100"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<el-button v-if="$utils.have('/activityFinanceSettle/receivablesInfo')" type="text" size="small"
							icon="el-icon-tickets" @click="$refs.dataView.show(scope.row)">结款信息</el-button>
						<el-button type="text" size="small" icon="el-icon-tickets"
							@click="load(scope.row.id)">下载结款单</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<DataView ref="dataView" @onUpdate="getDataList"></DataView>
		<ViewDetail ref="viewDetail" @onUpdate="getDataList"></ViewDetail>
		<Batch ref="batch" @onUpdate="getDataList"></Batch>
		<el-dialog title="导出费用明细提醒" :visible.sync="dialogVisible1" width="40%"
			v-if="downloadTips1 && downloadTips1 !=''"  @close="dialogVisible1=false;downLoading1 = false">
			<div class="dialog-content">
				<p class="color-warning MB20"><span class="el-icon-warning"></span> 你提交的导出任务，存在以下特殊情况，请针对这些特殊情况走单独的流程处理
				</p>
				<div v-if="downloadTips1 && Object.keys(downloadTips1).length" class="tips-main">
					<div v-for="(items, key) in downloadTips1" :key="key" class="tip-card">
						<div class="tip-header">
							{{ key }}
						</div>
						<ul class="tip-list">
							<li v-for="(item, index) in items" :key="index">
								{{ item }}
							</li>
						</ul>
					</div>
				</div>
				<div>
					<el-button type="primary" size="mini" icon="el-icon-document-copy"
						@click="copy1">复制异常提醒内容</el-button>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible1=false;downLoading1 = false">先不导出</el-button>
				<el-button type="primary" @click="doExport1(false)">我知道了，继续导出</el-button>
			</span>
		</el-dialog>
		<el-dialog title="异常结款单提醒" :visible.sync="dialogVisible2" width="40%"
			v-if="downloadTips2 && downloadTips2 !=''" @close ="dialogVisible2=false;downLoading2 = false;">
			<div class="dialog-content">
				<p class="color-warning MB20"><span class="el-icon-warning"></span> 你提交的导出任务，存在以下特殊情况，请针对这些特殊情况走单独的流程处理
				</p>
				<div v-if="downloadTips2 && Object.keys(downloadTips2).length" class="tips-main">
					<div v-for="(items, key) in downloadTips2" :key="key" class="tip-card">
						<div class="tip-header">
							{{ key }}
						</div>
						<ul class="tip-list">
							<li v-for="(item, index) in items" :key="index">
								{{ item }}
							</li>
						</ul>
					</div>
				</div>
				<div>
					<el-button type="primary" size="mini" icon="el-icon-document-copy"
						@click="copy2">复制异常提醒内容</el-button>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2=false;downLoading2 = false;">先不导出</el-button>
				<el-button type="primary" @click="doExport2(false)">我知道了，继续导出</el-button>
			</span>
		</el-dialog>
		<input class="copyTool" ref="copyTool1" :value="JSON.stringify(downloadTips1)" />
		<input class="copyTool" ref="copyTool2" :value="JSON.stringify(downloadTips2)" />
	</div>
</template>
<script>
	import DataView from './components/dataView';
	import ViewDetail from './components/viewDetail';
	import Batch from './components/batch';
	import {
		downloadFileTmp
	} from '@/assets/js/commonApi.js';
	const defaultParams = {
		pageNo: 1,
		queryKey: 1,
		queryValue: '',
		queryTimeKey: 2,
		queryTimeStart: '',
		queryTimeEnd: '',
		// type: 0,
		sellIdentity: 0,
		status: -1,
		balanceType: 0,
		isBalance: -1,
		showTypeTagId: "",
		siteTypeTagId: "",
		activityChannel: '',
		isNormalBalance: 1,
		settlementType: 0,
		specialSettlement: []
	}
	export default {
		components: {
			DataView,
			ViewDetail,
			Batch
		},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					queryKey: parseInt(this.$route.query.queryKey || 1),
					queryValue: this.$route.query.queryValue || '',
					queryTimeKey: parseInt(this.$route.query.queryTimeKey || 2),
					queryTimeStart: this.$route.query.queryTimeStart || '',
					queryTimeEnd: this.$route.query.queryTimeEnd || '',
					sellIdentity: parseInt(this.$route.query.sellIdentity || 0),
					settlementType: parseInt(this.$route.query.settlementType || 0),
					specialSettlement: this.$route.query.specialSettlement || [],
					status: parseInt(this.$route.query.status || -1),
					balanceType: parseInt(this.$route.query.balanceType || 0),
					isBalance: parseInt(this.$route.query.isBalance || -1),
					showTypeTagId: parseInt(this.$route.query.showTypeTagId) || "",
					siteTypeTagId: parseInt(this.$route.query.siteTypeTagId) || "",
					isNormalBalance: parseInt(this.$route.query.isNormalBalance || 1),
				},
				datetimerange: [this.$route.query.queryTimeStart || '', this.$route.query.queryTimeEnd || ''],
				listLoading: true,
				downLoading1: false,
				downLoading2: false,
				downLoading3: false,
				showTypeTagList: [],
				siteTypeTagList: [],
				activityChannel: [],
				dialogVisible1: false,
				downloadTips1: "",
				dialogVisible2: false,
				downloadTips2: "",
				copyTimer: null,
				copyTimer2: null,
			}
		},
		mounted() {
			this.getShowTypeTag();
			this.getSiteTypeTag();
			this.getDataList();
			this.getChannel()
		},
		methods: {
			//获取活动类型
			getShowTypeTag() {
				this.$request({
					url: "/styleTag/showType/all",
					method: "post",
					params: {
						isAll: 1
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.showTypeTagList = result || []
					}
				})
			},
			//获取场地类型
			getSiteTypeTag() {
				this.$request({
					url: "/styleTag/showType/site/all",
					method: "post",
					params: {
						isAll: 1
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.siteTypeTagList = result || []
					}
				})
			},
			//获取演出渠道
			getChannel() {
				this.$request({
					url: "/common/activitySource",
					method: "post",

				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.activityChannel = result || []
					}
				})
			},
			//获取列表
			getDataList() {
				this.listLoading = true;
				this.params = {
					...this.params,
					queryTimeStart: this.datetimerange && this.datetimerange[0] || '',
					queryTimeEnd: this.datetimerange && this.datetimerange[1] || ''
				}
				this.$request({
						url: "/activityFinanceSettle/settlementDoc/list",
						method: "POST",
						data: this.params,
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.datetimerange = [];
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
					specialSettlement: []
				};
				this.getDataList();
			},
			//导出费用明细
			async download1() {
				// let filePath;
				this.downLoading1 = true;
				try {
					const res = await this.$request({
							url: '/activityFinanceSettle/settlementDoc/exportInfo',
							method: 'post',
							data: {
								...this.params,
								check: true
							}
						})
					const {
						state,
						msg,
						result
					} = res.data;
					if (state != 1) {
						this.$message.error(msg || '导出失败');
						this.downLoading1 = false;
						return;
					}
					if (result.needTips == true) {
						this.downloadTips1 = result.tips
						this.dialogVisible1 = true
					} else {
						// 无需提示，检查接口已创建下载任务，直接提示成功
						this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
							confirmButtonText: '立即查看',
							cancelButtonText: '稍后再看',
							type: 'success',
							center: true,
							closeOnClickModal: false
						}).then(() => {
							this.$router.push({
								path: '/workbench/downloadList'
							});
						}).catch(() => {
							this.dialogVisible1 = false
							this.downLoading1 = false;
						});
					}
				} catch (err) {
					this.$message({
						message: err.message,
						type: 'error'
					});
					this.downLoading1 = false;
				}
			},
			async doExport1(check = false) {
			    // 开始加载
			    this.downLoading1 = true;
			    try {
			        const res = await this.$request({
			            url: '/activityFinanceSettle/settlementDoc/exportInfo',
			            method: 'post',
			            data: {
			                ...this.params,
			                check: check
			            }
			        });
			        const { state, msg, result } = res.data;
			        if (state != 1) {
			            this.$message.error(msg || '导出失败');
			            this.downLoading1 = false;
			            this.dialogVisible1 = false;
			            return;
			        }
			        // 任务创建成功
			        this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
			            confirmButtonText: '立即查看',
			            cancelButtonText: '稍后再看',
			            type: 'success',
			            center: true,
			            closeOnClickModal: false
			        }).then(() => {
			            this.$router.push({ path: '/workbench/downloadList' });
			        }).catch(() => {
						this.dialogVisible1 = false
						this.downLoading1 = false;
					});
			    } catch (err) {
			        this.$message.error(err.message || '请求错误');
			        this.downLoading1 = false;
			        this.dialogVisible1 = false;
			    }
			},
			//导出结款信息
			async download2() {
				// let filePath;
				this.downLoading2 = true;
				try {
					const res = await this.$request({
							url: '/activityFinanceSettle/settlementDoc/exportReceivables',
							method: 'post',
							data: {
								...this.params,
								check: true
							}
						})
					const {
						state,
						msg,
						result
					} = res.data;
					if (state != 1) {
						this.$message.error(msg || '导出失败');
						this.downLoading2 = false;
						return;
					}
					if (result.needTips == true) {
						this.downloadTips2 = result.tips
						this.dialogVisible2 = true
					} else {
						// 无需提示，检查接口已创建下载任务，直接提示成功
						this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
							confirmButtonText: '立即查看',
							cancelButtonText: '稍后再看',
							type: 'success',
							center: true,
							closeOnClickModal: false
						}).then(() => {
							this.$router.push({
								path: '/workbench/downloadList'
							});
						}).catch(() => {
							this.dialogVisible2 = false
							this.downLoading2 = false;
						});
					}
				} catch (err) {
					this.$message({
						message: err.message,
						type: 'error'
					});
					this.downLoading2 = false;
				}
			},
		async doExport2(check = false) {
		    // 开始加载
		    this.downLoading2 = true;
		    try {
		        const res = await this.$request({
		            url: '/activityFinanceSettle/settlementDoc/exportReceivables',
		            method: 'post',
		            data: {
		                ...this.params,
		                check: check
		            }
		        });
		        const { state, msg, result } = res.data;
		        if (state != 1) {
		            this.$message.error(msg || '导出失败');
		            this.downLoading2 = false;
		            this.dialogVisible2 = false;
		            return;
		        }
		        // 任务创建成功
		        this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
		            confirmButtonText: '立即查看',
		            cancelButtonText: '稍后再看',
		            type: 'success',
		            center: true,
		            closeOnClickModal: false
		        }).then(() => {
		            this.$router.push({ path: '/workbench/downloadList' });
		        }).catch(() => {
					this.dialogVisible2 = false
					this.downLoading2 = false;
				});
		    } catch (err) {
		        this.$message.error(err.message || '请求错误');
		        this.downLoading2 = false;
		        this.dialogVisible2 = false;
		    }
		},
		copy1() {
			clearTimeout(this.copyTimer1);
			this.copyTimer1 = setTimeout(() => {
				const e = this.$refs.copyTool1;
				e.select();
				document.execCommand("Copy"); // 执行浏览器复制命令
				this.$message.success("内容已复制，可粘贴");
				this.downLoading1 = false
			}, 300)
		},
		copy2() {
			clearTimeout(this.copyTimer2);
			this.copyTimer2 = setTimeout(() => {
				const e = this.$refs.copyTool2;
				e.select();
				document.execCommand("Copy"); // 执行浏览器复制命令
				this.$message.success("内容已复制，可粘贴");
				this.downLoading2 = false
			}, 300)
		},
		view(data) {
			this.$refs.viewDetail.show(data);
		},
		load(id) {
			this.loadbtnLoading = true
			let filePath;
			this.downLoading = true;
			this.$request({
				url: '/activityFinanceSettle/exportSettlement',
				method: 'POST',
				params: {
					id: id
				},
			}).then(res => {
				const {
					state,
					msg,
					result
				} = res.data;
				if (state == 1 && result) {
					filePath = result.url;
					downloadFileTmp(filePath, `${id}结算单.` + this.$utils.getFileType(filePath));
					this.loadbtnLoading = false;
				} else {
					this.loadbtnLoading = false;
					return this.$message.error(msg || '下载失败');
				}
			}).catch(() => {
				this.$message.error('请求错误');
			}).finally(() => {
				this.loadbtnLoading = false;
			});
		},
	}
	}
</script>

<style lang="scss" scoped>
	.popover-content {
		text-align: center;

		b {
			font-size: 18px;
		}

		p.color-info {
			font-size: 12px;
		}
	}

	.hand {
		cursor: pointer;
	}

	.ML5 {
		margin-left: 5px;
	}
	.tips-main{
		height: 300px;
		overflow-y: auto;
	}
	/* 卡片容器 */
	.tip-card {
		margin-bottom: 16px;
	}

	.tip-card:last-child {
		margin-bottom: 0;
	}

	/* 头部 – 直接显示完整 key */
	.tip-header {
		font-weight: 700;
		color: #1a2332;
		margin-bottom: 10px;
		word-break: break-word;
	}

	/* 列表样式 */
	.tip-list {
		list-style: none;
		margin: 0;
	}

	.tip-list li {
		padding: 6px 0;
		font-size: 14px;
		color: #3d4a5c;
		word-break: break-all;
	}

	.tip-list li:last-child {
		border-bottom: none;
	}

	.copyTool {
		opacity: 0;
		filter: alpha(opacity=0);
		// height: 1px;
	}
</style>